import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

axios.defaults.headers.common[
  "Authorization"
] = `Bearer ${window.localStorage.getItem("token")}`;

Vue.use(Vuex);

// Routes
import router from "@/router";

// Hooks
import dataValidates from "@/hooks/dataValidates";
import dataClear from "@/hooks/dataClear";
import authData from "@/data/authData";

// Timeout
let timer = null;

// Modules
import guides from "./modules/guides";
import promos from "./modules/promos";
import dashboard from "./modules/dashboard";
import modalpage from "./modules/modalpage";

export default new Vuex.Store({
  state: {
    title: "Travel Inspirator",
    token: null,
    auth: authData,
    authError: null,
    exit: null,
    users: [],
    usersKeys: [],
    usersTotal: null,
    usersPage: 1,
    csvLink: null,
  },

  getters: {
    // Valid Login
    getValidLogin: (state) => {
      return state.auth.email.error === "" && state.auth.password.error === ""
        ? true
        : false;
    },
  },

  actions: {
    // Set Page
    setUsersPage({ dispatch, commit }, value) {
      // set page to store current page that user pressed
      // values passed from emit fn
      // value.page -> current page
      // value.dispatchFn -> function to dispatch
      commit("setUsersPage", value.page);
      if (value.dispatchFn) {
        dispatch(value.dispatchFn, value.page);
      }
    },

    async getUserList({ commit }, page = 1) {
      axios.get(`/user/get/list?page=${page}`).then(({ data }) => {
        console.log(data);
        if (data.entities.length > 0) {
          commit("setUsers", data.entities);
          commit("setUsersTotal", data.total_count);
          commit("setKeys", Object.keys(data.entities[0]));
        }
      });
    },

    async getCsvLink({ commit }) {
      axios.get(`/user/get/list/csv`).then(({ data }) => {
        const backendUrl = process.env.VUE_APP_BACKEND_URL || process.env.VUE_APP_SERVER || '';
        const cleanBackendUrl = backendUrl.replace(/\/$/, '');
        const cleanPath = data.startsWith('/') ? data : '/' + data;
        commit("setCsvLink", `${cleanBackendUrl}${cleanPath}`);
      });
    },

    // Set Auth Token Action
    login({ state, commit, getters, dispatch }) {
      if (getters.getValidLogin) {
        const email = state.auth.email.value.trim().toLowerCase();
        const password = state.auth.password.value;

        axios
          .post("/auth/signin", { email, password })
          .then(({ data }) => {
            if (data && data.token && data.user) {
              // Check if user has admin role
              const hasAdminRole =
                data.user.roles &&
                data.user.roles.some((role) => role.name === "admin");

              if (hasAdminRole) {
                commit("setToken", data.token);
                router.push({ name: "Home" });
              } else {
                dispatch("setAuthError", "У вас нет прав администратора");
              }
            } else {
              dispatch("setAuthError", "Неправильный email или пароль");
            }
          })
          .catch(({ response }) => {
            const errorMessage =
              response?.data?.error || "Ошибка при входе. Попробуйте позже.";
            dispatch("setAuthError", errorMessage);
          });
      }
    },

    // Log Out Auth Action
    logOut({ state, commit }) {
      commit("setToken", null);
      commit("setForm", dataClear(new Object(state.auth), null));
      commit("setExit", false);
      router.push({ name: "Login" });
    },

    // Set Form Action
    setForm({ state, commit }, value) {
      commit("setForm", dataValidates(new Object(state.auth), value));
    },

    // Set Auth Error Action
    setAuthError({ commit }, value) {
      clearTimeout(timer);
      if (value) {
        commit("setAuthError", value);
        timer = setTimeout(() => {
          commit("setAuthError", null);
        }, 4000);
      }
    },

    // Set Exit Action
    setExit({ commit }, value) {
      commit("setExit", value);
    },
  },

  mutations: {
    // Set Auth Token Mutation
    setToken(state, value) {
      state.token = value;
      if (value) {
        localStorage.setItem("token", value);
      } else {
        localStorage.removeItem("token");
      }
    },

    // Set Form Mutation
    setForm(state, value) {
      state.auth = value;
    },

    // Set Auth Error Mutation
    setAuthError(state, value) {
      state.authError = value;
    },

    // Set Exit Mutation
    setExit(state, value) {
      state.exit = value;
    },

    setUsersPage(state, value) {
      state.usersPage = value;
    },

    setUsersTotal(state, value) {
      state.usersTotal = value;
    },
    setUsers(state, value) {
      state.users = value;
    },
    setKeys(state, value) {
      state.usersKeys = value;
    },
    setCsvLink(state, value) {
      state.csvLink = value;
    },
  },

  modules: {
    guides,
    promos,
    dashboard,
    modalpage,
  },
});
